import { createListenerMiddleware } from "@reduxjs/toolkit";
import { refreshDatasource } from "./dataSourceRefreshReducerSlice";

export const datasourceListenerMiddleware = createListenerMiddleware();

let refreshTimer = null;

const REFRESH_INTERVAL = 6 * 60 * 1000;
// const REFRESH_INTERVAL = 60 * 1000;

const clearRefreshTimer = () => {
  if (refreshTimer !== null) {
    clearTimeout(refreshTimer);
    refreshTimer = null;
    console.log("Refresh 6-min timer cleared");
  }
};

const startRefreshTimer = (dispatch) => {
  console.log("refresh startRefreshTimer");
  clearRefreshTimer();
  refreshTimer = setTimeout(() => {
    refreshTimer = null;
    console.log("refresh Timer FIRED:", new Date().toLocaleTimeString());
    dispatch(refreshDatasource());
  }, REFRESH_INTERVAL);
};

// RESET button
export const resetRefreshTimer = (dispatch) => {
  clearRefreshTimer();
  startRefreshTimer(dispatch);
};

export const startManualRefreshDs = (dispatch) => {
  console.log("refresh manually");
  clearRefreshTimer();
  dispatch(refreshDatasource());
};

// LISTENER HERE
datasourceListenerMiddleware.startListening({
  actionCreator: refreshDatasource.fulfilled,

  effect: async (action, listenerApi) => {
    startRefreshTimer(listenerApi.dispatch);
  },
});
